import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles({
  dropdown: {
    borderRadius: '20px',
    backgroundColor: '#fff',
    boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
    width: '500px',
    height: '350px',
    overflowY: 'auto',
    position: 'absolute',
    marginTop: '10px',
    zIndex: 1300
  }
});
